import Block from '../components/block';
import { RotateCw } from 'lucide-react';
import { Separator } from '../components/separator';
import Text from '../components/text';
import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';
import useGameInfo from '../../hooks/use-game-info';

export function TeamsName() {
  const { teams } = useGameInfo();

  return (
    <div className={'flex'}>
      <Separator colorDown={'#FFF'} />
      <Block className={'flex-center'} style={{ gap: 4, height: 60, width: '100%', paddingInline: 8 }}>
        <TeamName className={'flex-center'}>
          <Text color={'#FFF'} size={'large'} style={{ maxWidth: '100%' }}>
            {teams?.first.name}
          </Text>
        </TeamName>
        <RotateCw size={16} color={theme.colors.WhiteGray} />
        <TeamName className={'flex-center'}>
          <Text color={'#FFF'} size={'large'} style={{ maxWidth: '100%' }}>
            {teams?.second.name}
          </Text>
        </TeamName>
      </Block>
      <Separator colorDown={'#FFF'} />
    </div>
  );
}

const TeamName = styled.div`
  flex-grow: 48;
  flex-basis: 0;
  overflow: hidden;
  max-width: 100%;
`;
